import { AnyAction, createSlice } from '@reduxjs/toolkit';
import { ApiError } from '../../services/api';
import { RootState } from '../rootReducer';
import { IPermission } from './feature';
import {
  fetchPermissionsList
} from './list.thunks';

export interface FeatureListState {
  permissions: IPermission[];
  loading: boolean;
  error: ApiError | null;
}

const initialState: FeatureListState = {
  error: null,
  loading: false,
  permissions: []
};

const getPermissionListState = (state:RootState):FeatureListState => state.features.list;
const getError = (state:RootState):ApiError | null => getPermissionListState(state).error;
const getList = (state:RootState):IPermission[] => getPermissionListState(state).permissions;
const getLoading = (state:RootState):boolean => getPermissionListState(state).loading;

export const selectors = {
  getError,
  getList,
  getLoading
};

const extraReducers = {
  [fetchPermissionsList.pending.type]: (state: FeatureListState):void => {
    state.loading = true;
    state.permissions = [];
  },
  [fetchPermissionsList.fulfilled.type]: (state: FeatureListState, action: AnyAction):void => {
    state.loading = false;
    state.permissions = action.payload;
  },
  [fetchPermissionsList.rejected.type]: (state: FeatureListState, action: AnyAction):void => {
    state.loading = false;
    state.error = action.payload;
  }
};

const featuresListSlice = createSlice({
  name: 'features',
  initialState,
  reducers: {},
  extraReducers
});

export default featuresListSlice.reducer;
export const actions = {
  ...featuresListSlice.actions,
  fetchFeaturesList: fetchPermissionsList
};
